import { type DeletedItemEntry } from './indexedDBAdapter';

// A versionless tombstone (legacy or user-communication-style) suppresses any
// event for that id. A versioned one only suppresses same-or-older events, so
// restores and move-backs carrying a strictly newer version pass through.
export const shouldSuppressByTombstone = (
  record: DeletedItemEntry | undefined,
  itemVersion: number | null | undefined,
): boolean => {
  if (!record) {
    return false;
  }
  if (record.version == null || itemVersion == null) {
    return true;
  }
  return itemVersion <= record.version;
};
